/* eslint-disable */
import gsap from 'gsap'
import { MorphSVGPlugin } from 'gsap/MorphSVGPlugin'
import { MotionPathPlugin } from 'gsap/MotionPathPlugin'

gsap.registerPlugin(MorphSVGPlugin, MotionPathPlugin)
export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {


    /* eslint-disable */

    // Check if content is ready
    // let content_loaded = setInterval( () => {
    //   if (document.readyState == "complete") {
    //     clearInterval(content_loaded);
    //     if (document.body.classList.contains('home')) {
    //       announcement_bar();
    //     }
    //   }
    // }, 1);

    function announcement_bar() {
      let bar = document.querySelector('.announcement-bar');
      if (bar.classList.contains('active')) {
        bar.classList.add('active');
        bar.style.opacity = 1;


        let close_bar = bar.querySelector('.close-announcement-bar');
        close_bar.addEventListener('click', (event) => {
          event.preventDefault();
          // let bar = event.target.closest('announcement-bar');
          bar.classList.remove('active');
          bar.style.opacity = 0;
        })
      }
    }
    announcement_bar()

    /* Find the largest number in the array */
    function largest_number(arr) {
      return Math.max.apply(null, arr);
    }

    /* Resets the lightSlider height on load */
    function edit_slider_width(element, time_delay) {
      setTimeout(function() {
      // Refreshes slider
      element.refresh();

      // Gets the slider
      let slider_id = element.selector;
      slider_id = slider_id.substring(1, slider_id.length);

      let slider = document.getElementById(slider_id);
      let slide_li = document.querySelectorAll(element.selector + ' li');
      let tallest_li = [];

      // Get gets each li height
      slide_li.forEach(slide => {
        tallest_li.push(slide.clientHeight);
      });

      var max = largest_number(tallest_li);

      // Sets ul slider height
      let width = window.innerWidth;

      if (width <= 768) {
        slider.style.height = (max + 40) +  'px';
      } else {
        slider.style.height = (max + 80) +  'px';
      }

      }, time_delay);
    }
    /* eslint-enable */

    jQuery('document').ready( function() {
      // Home Yelp Slider
      if( document.body.classList.contains('home')) {
        $('#yelp-slider').lightSlider({
          item: 2,
          slideMargin: 60,
          // mode: 'slide',
          mode: 'slide',
          enableDrag: true,
          loop: true,
          controls: false,
          responsive : [
            {
                breakpoint: 1024,
                settings: {
                  item: 1,
                  slideMargin: 40,
                },
            },
          ],

          onSliderLoad: function (el) {
            edit_slider_width(el, 600);
          },
        })
      }

      /*
        remove_extra_gallery_class
        - Removes all extra classes on a slider li
      */
      function remove_extra_gallery_class(id_name) {
        let li = document.querySelectorAll('#' + id_name + ' li');
        for (let a = 0; a < li.length; a++) {
          li[a].classList.remove('active-second');
        }
      }

      /* eslint-disable */
      if( document.body.classList.contains('home')) {
        $('#modal-gallery').lightSlider({
          item: 1,
          slideMargin: 0,
          mode: 'slide',
          enableDrag: true,
          loop: true,
          controls: false,
          keyPress: true,
          pager: false,

          onSliderLoad: function (el) {
            edit_slider_width(el, 2000);
            gallery_counter('gallery-modal', el);

            if (el.id = 'modal-gallery') {
              setTimeout( () => {
                let left = document.querySelectorAll('#' + el.id + ' li.clone.left img');
                left.forEach(left => { left.classList.add('animate-item'); });
                let right = document.querySelectorAll('#' + el.id + ' li.clone.right img');
                right.forEach(right => { right.classList.add('animate-item'); });
              }, 1000);
            }
          },
          onBeforeSlide: (el) => {
            remove_extra_gallery_class('gallery-modal');
            gallery_counter('gallery-modal', el);
          },
          onAfterSlide: (el) => {
            // Total slides - if infinite
            let total_slides = document.querySelectorAll('#modal-gallery li').length - 2;

            // Adds class to combat lightSkider inifite slide flash
            if (el.getTotalSlideCount() == total_slides && el.getCurrentSlideCount() == 1) {
              if (document.querySelector('#modal-gallery .clone.right').classList.contains('active')) {
                document.querySelectorAll('#modal-gallery li')[1].classList.add('active-second');
              }
            }
            else if (el.getTotalSlideCount() == total_slides && el.getCurrentSlideCount() == total_slides) {
              if (document.querySelector('#modal-gallery .clone.left').classList.contains('active')) {
                document.querySelectorAll('#modal-gallery li')[total_slides].classList.add('active-second');
              }
            }
          },
        })
      }
    });

    function gallery_counter(modal_id, el) {
      let slider = el;
      let current = document.querySelector('#' + modal_id + ' #slider-counter .current');
      let total = document.querySelector('#' + modal_id + ' #slider-counter .total');

      current.textContent = slider.getCurrentSlideCount();
      total.textContent = slider.getTotalSlideCount();
    }

    // function get_json(url) {
    //     var xhr = new XMLHttpRequest();
    //     xhr.open("GET", url, true);
    //     xhr.onreadystatechange = function() {
    //       if (xhr.readyState == 4) {
    //         console.log(xhr.responseText);
    //         // console.log(xhr.readyState, xhr.responseText, typeof xhr.responseText);
    //         // console.log(xhr.readyState);
    //         // console.log(xhr.responseText);
    //         // document.getElementById('aquity-content').innerHTML = xhr.responseText;
    //         // var resp = JSON.parse(xhr.responseText);
    //       }
    //     }
    //     xhr.send();
    // }

    // console.log(fetch("https://acuityscheduling.com/api/v1/appointments.json?max=25&calendarID=142114"));
    // get_json("https://acuityscheduling.com/api/v1/appointments.json?max=25&calendarID=142114");

    /*
      get_barber_nodes
      - gets only the barber div's
        - used to gather the index of the barber
    */
    function get_barber_nodes() {
      // Remove text nodes
      let content = new Array();
      console.log(document.getElementById('barbers-team'));
      console.log(document.getElementById('barbers-team').children);
      console.log(document.getElementById('barbers-team').childNodes);
      let barber_row = document.getElementById('barbers-team').childNodes;
      barber_row.forEach( (barber) => {
        if (barber.classList != null) {
          content.push(barber);
        }
      });
      console.log('content', content);
      return content;
    }
    /*
      fill_barber_object
      - gets the barbers information
      - creates an object
      - adds that content to object
    */
    let barber = new Object();
    function fill_barber_object(barber) {
      let content = new Array();
      let barber_content = {};

      content = get_barber_nodes();

      // Add barber information to the object
      for(let a = 0; a < content.length; a++) {
        let current_barber = new Array();

        current_barber.id = content[a].id;
        current_barber.name = content[a].querySelector('.name').textContent;
        current_barber.image = [
          content[a].querySelector('img').getAttribute('src'),
          content[a].querySelector('img').getAttribute('alt'),
        ];
        current_barber.instagram = [
          content[a].querySelector('.read-bio').getAttribute('data-instagram-url'),
          content[a].querySelector('.read-bio').getAttribute('data-instagram-handle'),
        ];
        current_barber.bio = unwrap_dataset_tags(content[a].querySelector('.read-bio').getAttribute('data-bio'));

        barber_content[a] = new Object(current_barber);
      }
      return barber_content;
    }

    window.addEventListener('DOMContentLoaded', () => {
      barber = fill_barber_object();

      setTimeout( () => {
        if ( document.querySelector('.ff-stream')) {
          create_instagram_from_flow_flow('ff-stream-1')
        }
      }, 1000);
    });



    let animate_items_out = '';

    function open_modal(event, add_id) {
      event.preventDefault();
      let modal_name = '';

      document.querySelector('.bws-header').classList.add('modal-open');

      // Used to allow appended elements to call modals
      if (add_id != '') {
        modal_name = add_id.split('/');
        modal_name = modal_name[modal_name.length - 1];
        modal_name = modal_name.substring(1, modal_name.length);
      } else {
        modal_name = event.target.getAttribute('href').toLowerCase();
      }

      let modal = document.querySelector('#' + modal_name);
      let animated_items = modal.querySelectorAll('.animate-item');


      if (modal_name == 'barber-modal') {
        let barber_id = event.target.parentElement.id;
        let barbers_div = get_barber_nodes();
        let current_index = 0;

        // Get the current barber index
        for (let a = 0; a < barbers_div.length; a++) {
          if (barbers_div[a].id === barber_id) {
            current_index = a;
          }
        }

        // Get modal elements
        let barber_modal_elements = new Object();
        barber_modal_elements.modal_name = document.getElementById('barber-modal');
        barber_modal_elements.content = barber_modal_elements.modal_name.querySelector('.barber-column');
        barber_modal_elements.name = barber_modal_elements.modal_name.querySelector('.barber-name');
        barber_modal_elements.bio = barber_modal_elements.modal_name.querySelector('.barber-bio .column-one');
        barber_modal_elements.columns = barber_modal_elements.content.querySelectorAll('.barber-content [class*=col-]');
        barber_modal_elements.image = barber_modal_elements.modal_name.querySelector('img');
        barber_modal_elements.instagram = [
          barber_modal_elements.modal_name.querySelector('.icon-button').childNodes[3],
          barber_modal_elements.modal_name.querySelector('.icon-button'),
        ];


        // Fill in modal content - with that barbers
        barber_modal_elements.image.src = barbers_div[current_index].querySelector('img').getAttribute('src')
        barber_modal_elements.image.alt = barbers_div[current_index].querySelector('img').getAttribute('alt')
        barber_modal_elements.name.textContent = barbers_div[current_index].querySelector('.name').textContent;
        barber_modal_elements.instagram[0].textContent = barbers_div[current_index].querySelector('.read-bio').dataset.instagramHandle
        barber_modal_elements.instagram[1].href = barbers_div[current_index].querySelector('.read-bio').dataset.instagramUrl

        // Add barber bio
        let new_paragraph = document.createElement('p');
        barber_modal_elements.bio.appendChild(new_paragraph).innerHTML = barbers_div[current_index].querySelector('.read-bio').dataset.bio;

        // Move the button below the bio
        let buttons = barber_modal_elements.bio.children[0].cloneNode(true);
        barber_modal_elements.bio.children[0].remove();
        barber_modal_elements.bio.appendChild(buttons);

        // Add the barbers name to the button
        barber_modal_elements.button =  barber_modal_elements.modal_name.querySelector('.regular-button');
        barber_modal_elements.button.childNodes[1].textContent = 'Book ' + barbers_div[current_index].querySelector('.name').textContent;

        modal.classList.add('active');
        document.body.classList.add('no-overflow');

        /* eslint-disable */
        let animate_count = 0.2;
        animated_items.forEach(item => {
          gsap.to(item, {
            opacity: 1,
            delay: animate_count,
            duration: 1,
            y: 0,
            // ease: Quint.easeOut,
            ease: 'power1.inOut',
          })
          animate_count += 0.2;
        });
        /* eslint-enable */

        modal_link = document.querySelectorAll('.modal-link');
      } else {
        modal.classList.add('active');
        document.body.classList.add('no-overflow');

        /* eslint-disable */
        let animate_count = 0.2;
        animated_items.forEach(item => {
          gsap.to(item, {
            opacity: 1,
            delay: animate_count,
            duration: 1,
            y: 0,
            // ease: Quint.easeOut,
            ease: 'power1.Out',
          })
          animate_count += 0.2;
        });
        /* eslint-enable */
      }

      // Used in modal close - to animate elements out
      return animate_items_out = reverse_array(animated_items);
    }

    let modal_link = document.querySelectorAll('.modal-link');
    Array.prototype.forEach.call(modal_link, (link) => {
      link.addEventListener('click', () => {
        open_modal(event, '');
      });
    });

    // Used to add click events to appended elements
    document.body.addEventListener('click', (event) => {
      // console.log(event.target);
      if (event.target.classList.contains('appended-modal-link')) {
        open_modal(event, event.target.href.toLowerCase());
      }
    });

     /* eslint-disable */

    function reverse_array(arr) {
      let new_arr = new Array();
      for (var i = arr.length -1; i >= 0; i-- ) {
        new_arr.push(arr[i]);
      }
      return new_arr;
    }

    let barber_row = document.querySelectorAll('#barbers-team .barber-col');
    /*
      on mouse over - makes it active - tracks mouse move
    */
    barber_row.forEach( item => {
      console.log('item', item);
      let plus = item.querySelector('svg');
      let element_dimensions = '';

      item.addEventListener('mousemove', (event) => {
        if (window.innerWidth > 1024) {

          item.classList.add('active', 'no-cursor');
          element_dimensions = event.target.getBoundingClientRect();

          if (event.target.classList.contains('absolute-link')) {
          /* eslint-disable */
          gsap.to(plus, {
            x: (event.clientX - (element_dimensions.left) - (element_dimensions.width / 2) ),
            y: (event.clientY - (element_dimensions.top) - element_dimensions.height),
            opacity: 0,
            duration: 0,
          })
          gsap.to(plus, {
            duration: 0.5,
            // ease: Quint.easeOut,
            ease: 'power1.Out',
            x: (event.clientX - (element_dimensions.left) - (element_dimensions.width / 2) ),
            y: (event.clientY - (element_dimensions.top) - element_dimensions.height),
            scale: 1.2,
            opacity: 1,
            rotate: '360deg',
          })
          /* eslint-enable */
          }
        }
      });

      item.addEventListener('mouseleave', () => {
        if (window.innerWidth > 1024) {
          item.classList.remove('active', 'no-cursor');
          /* eslint-disable */
          // let plus_timeline = new TimelineMax();
          let plus_timeline = gsap.timeline()

          plus_timeline.to(plus, {
            duration: 0.5,
            // ease: Quint.easeOut,
            ease: 'power1.out',
            opacity: 0,
            rotate: '0deg',
          })
          plus_timeline.to(plus, {
            duration: 0.5,
            // ease: Quint.easeOut,
            ease: 'power1.out',
            x: (event.clientX - (element_dimensions.left) - (element_dimensions.width / 2) ),
            y: (event.clientY - (element_dimensions.top) - element_dimensions.height),
            scale: 0,
            opacity: 0,
            rotate: '0deg',
          })
          /* eslint-enable */
        }
      });
    })

    /*
      close_modal
      - animates out the content out
      - removes active class
    */
    function close_modal(event) {
      event.preventDefault();

      let modal_id = event.target.getAttribute('href');
      let current_modal = document.getElementById(modal_id);
      let total = 0;
      let animate_items = '';
      let double_modal = false;

      // See's how many modals are open
      if (document.querySelectorAll('.bws-modal.active').length < 1) {
        double_modal = true;
      } else if (document.querySelectorAll('.bws-modal.active').length == 1) {
        double_modal = true;
      }

      if (current_modal.querySelectorAll('.animate-item').length > 0) {
      animate_items = current_modal.querySelectorAll('.animate-item');
      /* eslint-disable */
        // Animate the elements out
        let animate_count = 0.2;
        animate_items.forEach(item => {
          gsap.to(item, {
            opacity: 0,
            delay: 0.3,
            duration: 0.3,
            y: -30,
            // ease: Quint.easeOut,
            ease: 'power1.out',
          });
          /* eslint-enable */
          animate_count += 0.2;
        });

        total = 600;
      } else {
        total = 200;
      }

      setTimeout( () => {
        if (modal_id == 'barber-modal') {
          let bio = current_modal.querySelectorAll('.barber-bio p');
          // Remove current barber bio
          for (let a = 0; a < bio.length; a++) {
            bio[a].remove();
          }
        }

        if (double_modal) {
          document.querySelector('.bws-header').classList.remove('modal-open');
          document.body.classList.remove('no-overflow');
        }

        current_modal.classList.remove('active');

      }, total);
    }

    let modal_close = document.querySelectorAll('.close-modal-trigger');
    modal_close.forEach( (item) => {
      item.addEventListener('click', close_modal);
    });

    /* eslint-disable  */

    function sticky_header() {
      const scroll = window.pageYOffset;

      if (scroll > 100) {
        document.querySelector('.bws-header').classList.add('sticky');
        document.querySelector('#appointment-form .shadow-wrap').classList.add('sticky');
      } else if (scroll <= 99) {
        document.querySelector('.bws-header').classList.remove('sticky');
        document.querySelector('#appointment-form .shadow-wrap').classList.add('sticky');
      }
    }

    function parallax_items() {
      const topViewport = window.pageYOffset;
      const midViewport = topViewport + (window.innerHeight / 2);

      sections.forEach(section => {
        const topSection = section.offsetTop;
        const midSection = topSection + (section.offsetHeight / 2);
        const distanceToSection = midViewport - midSection;
        const parallaxTags = section.querySelectorAll('[data-parallax]');

        // loop over each parallax tag
        parallaxTags.forEach(tag => {
          const speed = parseFloat(tag.getAttribute('data-parallax'));
          if (tag.offsetParent.id == "home-section-six" && window.innerWidth <= 768) {
            tag.style.transform = `translate(0, ${ distanceToSection * speed }px) rotate(180deg)`;
          } else {
            tag.style.transform = `translate(0, ${ distanceToSection * speed }px)`;
          }

        });
      });
    }

    const sections = document.querySelectorAll('section');
    const parallaxTags = document.querySelectorAll('[data-parallax]');

    document.addEventListener('scroll', function() {
      sticky_header();

      // Removes parallax on parallx attribute items
      if (window.innerWidth > 1024) {
        parallax_items();
      } else {

        parallaxTags.forEach( item => { item.setAttribute('style','') } );
      }
    });

    // Removes parallax on parallx attribute items - on reisze
    document.addEventListener('resize', function() {
      if (window.innerWidth <= 768) {
        parallaxTags.forEach( item => { item.setAttribute('style','') } );
      }
    });

    /* eslint-disable */
    /*
      unwrap_dataset_tags
      - removes both paragraphs tags from acf field
    */
    function unwrap_dataset_tags(tag) {
      let temp_arr = new Array;
      let result = new Array;

      if (tag.indexOf('<p>') == 0) {
        temp_arr = tag.split('<p>');

        for( let a = 0; a < temp_arr.length; a++) {
          if (temp_arr[a] != "") {
            let temp = '';
            temp = temp_arr[a].split('<p>');
            temp = temp_arr[a].split('</p>');
            result.push(temp[0]);
          }
        }

        return result;
      }
    }

    let scroll_anchor = document.querySelectorAll('.anchor-scroll');
    scroll_anchor.forEach( scroll => {
      scroll.addEventListener('click', scroll_to_item);
    });

    function scroll_to_item(event) {
      event.preventDefault();
      let hash = event.target.href.split('/');
      let distance = '';
      hash = hash[hash.length - 1];

      let width = window.innerWidth;

      if (width <= 768) {
        distance= parseInt(document.getElementById(hash).offsetTop) - 80;
      } else {
        distance= parseInt(document.getElementById(hash).offsetTop);
      }


      let scroll = document.body;

      setTimeout(function() {
        /* eslint-disable */
        gsap.to(window, {duration: 1, scrollTo: distance});
        /* eslint-enable */
      }, 400);
    }


    function create_instagram_from_flow_flow(ff_stream_id) {
      let instagram_feed = document.getElementById('instagram-list');
      let flow_flow = document.getElementById(ff_stream_id);
      let posts = flow_flow.querySelectorAll('article');
      let posts_content = [];

      // Removes extra post
      if (window.innerWidth > 577) {
        posts = Array.from(posts);
        posts.splice(-1, 1);
      }

      // Gets the data
      posts.forEach(post => {
        let image_src = post.dataset.media.split(';');
        let instagram_link = post.querySelector('.ff-item-bar .ff-likes').getAttribute('href');
        posts_content.push([image_src[2], instagram_link]);
      });

      // Append li's
      posts_content.forEach(post => {
        let new_post = document.createElement('li');
        instagram_feed.appendChild(new_post).innerHTML = `
            <div class="inner-wrap" style="background: url('${ post[0] }') no-repeat center center; background-size: cover">
              <a href="${ post[1] }" target=_blank" class="absolute-link"></a>
            </div>
          `;
      });

      // Assigns classes to appended li
      let li = instagram_feed.querySelectorAll('li');
      li.forEach(li => { li.classList.add('col-lg-4', 'col-md-4', 'col-sm-4', 'col-xs-4') });
    }


    let regular_buttons = document.querySelectorAll('.regular-button');

    regular_buttons.forEach(button => {
      let svg = button.querySelector('path');
      let original_path = svg.getAttribute('d');
      // let element_dimensions = '';

      /* eslint-disable */
      MorphSVGPlugin.convertToPath(svg);

      button.addEventListener('mousemove', (event) => {
        if (window.innerWidth > 1024) {
          if (event.target.classList != null && event.target.classList.contains('regular-button')) {

            gsap.to(svg, {
              duration: 0.8,
              x: ((event.offsetX / 5) * -0.29) + 17,
              y: ((event.offsetY / 5) * 1.7) - 30,
              // ease: Quint.easeOut,
              ease: 'power1.out',
              opacity: 0.2,
              morphSVG: "M4.4,71.9h316c1.7,0,3-1.3,3-3v-64c0-1.7-1.3-3-3-3H4.4c-1.7,0-3,1.3-3,3v64C1.4,70.5,2.8,71.9,4.4,71.9z",
            })
            /* eslint-enable */
          }
        }
      })

      button.addEventListener('mouseout', () => {
        if (window.innerWidth > 1024) {
          /* eslint-disable */
          gsap.to(svg, {
            duration: 0.8,
            x: 0,
            y: 0,
            // ease: Quint.easeOut,
            ease: 'power1.Out',
            opacity: 0.1,
            morphSVG: original_path,
          })
          /* eslint-enable */
        }
      })
    });

    let line_buttons = document.querySelectorAll('.gradient-line-button');

    line_buttons.forEach(button => {
      let svg = button.querySelector('path');
      let original_path = svg.getAttribute('d');

      /* eslint-disable */
      MorphSVGPlugin.convertToPath(svg);

      button.addEventListener('mousemove', (event) => {
        if (window.innerWidth > 1024) {
          if (event.target.classList != null && event.target.classList.contains('gradient-line-button')) {

            gsap.to(svg, {
              duration: 0.8,
              // x: (event.clientX - (element_dimensions.left) - (element_dimensions.width / 2) ) + (element_dimensions.left / 4),
              // y: (event.clientY - (element_dimensions.top) - element_dimensions.height) + 50,
              x: ((event.offsetX / 2) * 1.2),
              y: ((event.offsetY / 2) * 1.7),
              // ease: Quint.easeOut,
              ease: 'power1.Out',
              scale: 1.2,
              morphSVG: "M47,6.9c0.1,0,0.1,0,0.2,0c0,0.1-0.1,0.2-0.2,0.2C46.8,7.1,46.8,7,47,6.9 M45,10.9 c0.1,0,0.1,0,0.1,0.1c0,0.1-0.1,0.1-0.2,0.1C44.8,11,44.8,10.9,45,10.9 M44,9.9c0,0,0.1,0,0.1,0.1c0,0,0,0.1-0.1,0.1 C44,10.1,43.9,10,44,9.9C43.9,10,43.9,9.9,44,9.9 M44,10.9C44.1,10.9,44.1,11,44,10.9c0.1,0.1,0,0.1,0,0.1 C43.9,11.1,43.9,11,44,10.9C44,11,44,10.9,44,10.9 M43.5,10.9c0.4,0,0.6,0.1,0.3,0.1c-0.2,0-0.9,0-0.8-0.1 C43,11,43.3,10.9,43.5,10.9 M43,10.9c0,0,0.1,0,0.1,0.1c0,0,0,0.1-0.1,0.1C43,11.1,42.9,11,43,10.9C42.9,11,42.9,10.9,43,10.9 M40.5,9.9c0.3,0,0.5,0,0.5,0c0,0-0.1,0-0.3,0.1c-0.2,0-0.4,0-0.5,0C39.9,9.9,40,9.9,40.5,9.9 M39.6,9.9c0.3,0,0.4,0,0.4,0.1 c0,0.1-0.8,0.1-0.9,0C38.9,10,39.2,9.9,39.6,9.9 M39,10.9C39,10.9,39,11,39,10.9c0.1,0.1,0.1,0.2,0,0.2C39,11.1,38.9,11,39,10.9 C38.9,11,39,10.9,39,10.9 M36,10.9C36.1,10.9,36.1,11,36,10.9c0.1,0.1,0,0.1,0,0.1C35.9,11.1,35.9,11,36,10.9C36,11,36,10.9,36,10.9 M35.5,6.9c0.5,0,0.7,0.1,0.3,0.1C35.5,7.1,35,7,35,7C35,7,35.2,6.9,35.5,6.9 M35,10.9c0.1,0,0.1,0,0.1,0.1c0,0-0.1,0.1-0.2,0.1 c-0.1,0-0.1,0-0.1-0.1C34.9,11,34.9,10.9,35,10.9 M35,10C35.2,10,35.2,10,35,10c-0.1,0.1-0.2,0.1-0.2,0.1C34.8,10,34.9,9.9,35,10 M34.1,9c0.1,0,0.1-0.1,0.2-0.2c0-0.1,0.1-0.1,0.1,0c0,0,0.2,0.1,0.3,0.1c0.2,0,0.3,0,0.3,0.1c0,0,0,0.1-0.1,0c0,0-0.2,0-0.3,0.1 C34.4,9.2,34,9.2,34,9.1C34,9.1,34,9.1,34.1,9 M34.1,9C34.1,9,34.1,9,34.1,9c-0.2,0-0.2,0-0.1,0C34,9,34,9,34.1,9 M33,10.9 c0.1,0,0.1,0,0.1,0.1c0,0-0.1,0.1-0.2,0.1c-0.1,0-0.1,0-0.1-0.1C32.9,11,32.9,10.9,33,10.9 M32.2,8.9c0.1,0,0.3-0.1,0.3-0.1 C32.6,8.8,33,9,33,9.1c0,0.1-0.1,0.1-0.5,0C31.9,9.1,31.9,9,32.2,8.9 M31,9.9C31.1,9.9,31.2,10,31,9.9C31.1,10,31,10.1,31,9.9 C30.8,10,30.8,9.9,31,9.9 M31.8,8.9C32.1,8.9,32,9,31.7,9c-0.2,0-0.3,0-0.3,0.1c0,0.1,0,0.1-0.1,0c0,0-0.1-0.1-0.2-0.1 C31.1,9,31,9,31,9C31,8.9,31.5,8.8,31.8,8.9 M31.1,10C31.1,10,31.1,10.1,31.1,10c-0.2,0.1-0.2,0.1-0.1,0C31,9.9,31,9.9,31.1,10 M30,8.9c0,0,0.1,0,0.1,0.1c0.1,0.1,0,0.2-0.2,0.2C29.8,9.1,29.8,8.9,30,8.9 M28.1,9.1c0.1,0,0.2,0,0.3-0.1c0.2-0.2,0.4-0.2,0.5-0.1 c0.1,0.1,0,0.3-0.3,0.2c-0.1,0-0.2,0-0.3,0c-0.1,0.1-0.4,0.1-0.4,0C28,9.1,28.1,9.1,28.1,9.1 M27,8c0.1,0,0.3,0,0.2,0 c-0.1,0.1-0.3,0.1-0.3,0C26.8,8,26.9,8,27,8 M26.1,6.9c0.1,0,0.1,0,0.1,0.1c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0-0.2,0c-0.1,0-0.1,0,0-0.1 C25.9,7,26,6.9,26.1,6.9 M24.2,10c0.1,0,0.3,0,0.4,0c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.2-0.1,0.2,0c0,0.1-0.3,0.2-0.7,0.2 C24,10.1,23.9,10.1,24.2,10 M23.2,8.8c0.2-0.1,0.3-0.1,1.3-0.1c1.5,0,1.5,0,1.4,0.1C25.7,8.9,25.8,9,26,9c0.1,0,0.2,0,0.2,0 c0,0,0.5,0,1,0C27.8,9,28,9,28,9c0,0-0.1,0.1-0.1,0.1s-0.1,0-0.2,0c0,0-0.3,0-0.6,0.1c-0.4,0-0.6,0-0.6-0.1c0-0.1-0.1-0.1-0.1,0 c0,0-0.2,0-0.2,0c-0.1,0-0.2,0-0.2,0c0,0,0,0.1-0.1,0.1c0,0-0.1,0-0.1-0.1c0-0.1-0.6-0.2-0.9-0.1c-0.1,0-0.3,0.1-0.4,0.1 c-0.1,0-0.2,0-0.3,0.1c-0.1,0-0.1,0-0.1,0c0-0.1,0-0.1-0.1,0c-0.1,0.1-0.8,0.1-1,0C22.9,9.1,23,9,23.2,8.8 M22.1,9 c0.1,0,0.2,0,0.2-0.1c0,0,0.2-0.1,0.4-0.1c0.4,0,0.5,0.1,0.1,0.1C22.3,9.1,22,9.2,22,9.1C22,9.1,22.1,9,22.1,9 M22.1,10 c0.2,0,0.2,0,0.2-0.1c0,0,0-0.1,0.1-0.1c0,0,0.1,0,0.1,0.1c0,0.1,0,0.1,0.2,0c0.1-0.1,0.2-0.1,0.3,0C23,10,23,10,22.9,10 c0,0-0.1,0-0.2,0.1c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3,0C22.1,10.1,22,10.1,22.1,10C22,10,22,10,22.1,10 M21.1,10 c0.1,0.1,0,0.1-0.1,0.1c-0.1,0-0.1-0.1,0-0.1C21,9.9,21,10,21.1,10 M19.1,8.8c0.1,0,0.5-0.1,1.3-0.1c1,0,1.2,0,1.4,0.1 C22.1,9,22,9.1,21.6,9.1c-0.2,0-0.4,0-0.4,0c-0.1-0.1-0.7,0-1,0.1c-0.2,0.1-0.3,0.1-0.4,0c-0.1-0.1-0.2-0.1-0.2,0 c-0.1,0.1-0.1,0.1-0.2,0c-0.1,0-0.2,0-0.2,0c0,0,0,0-0.1,0C19,9.1,19,8.9,19.1,8.8 M17.4,9.9c0.1-0.1,0.6,0,0.6,0.1 c0,0.1-0.1,0.1-0.4,0.1c-0.5,0-0.7,0-0.4-0.1C17.2,10,17.3,10,17.4,9.9 M17,9.9C17,9.9,17.1,10,17,9.9c0.1,0.1,0,0.1,0,0.1 C17,10.1,16.9,10,17,9.9C16.9,10,17,9.9,17,9.9 M16,8c0,0,0.1,0,0.1,0C16.1,8,16.1,8,16,8C15.9,8.1,15.9,8.1,16,8 M16,7.9 C16.1,7.9,16.1,7.9,16,7.9c0.1,0.1,0,0.2,0,0.2C15.9,8.1,15.9,8,16,7.9 M13.1,8c0,0,0,0.1-0.1,0.1c-0.2,0-0.2,0-0.1-0.1 C13,7.9,13.1,7.9,13.1,8 M13,9.9c0.2,0,0.2,0.1,0.1,0.1c-0.1,0-0.4,0-0.3-0.1C12.8,9.9,12.9,9.9,13,9.9 M12.3,8.9 C12.3,8.9,12.4,8.9,12.3,8.9c0.1-0.1,0.8-0.1,2-0.1c0.2,0,1,0,1.9,0c1.3,0,1.6,0,1.7,0C18.1,9,18,9.1,17.8,9.1c-0.1,0-0.2,0-0.3,0.1 c0,0-0.1,0.1-0.1,0c0-0.1-0.8-0.1-0.9,0c-0.1,0-0.5,0-0.7,0c-0.1,0-0.1,0-0.1,0c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0-0.1-0.1 c0-0.1-0.1-0.1-0.3-0.1c-0.2,0-0.3,0-0.3,0c0,0,0,0-0.1,0c-0.1,0-0.3,0-0.5,0c0,0-0.1,0-0.2,0c-0.1,0-0.3,0-0.5,0 C13.4,9,13.1,9,13,9.1c0,0-0.1,0-0.1,0c-0.1-0.1-0.3,0-0.4,0.1c0,0-0.1,0-0.1,0c0,0-0.1-0.1-0.1,0c0,0-0.1,0-0.2-0.1 c-0.1-0.1-0.1-0.1,0-0.1C12.2,8.9,12.3,8.9,12.3,8.9 M11.3,8c0.2,0,0.4,0,0.5,0c0.1,0,0.2,0,0.2,0c0,0-0.1,0.1-0.5,0.1 c-0.3,0-0.5,0-0.5,0C11,8,11.1,8,11.3,8 M11,7.9c0.3,0,0.3,0.1,0,0.2c-0.1,0-0.2,0-0.3,0C10.7,8,10.8,7.9,11,7.9 M9.9,7.9 c0.1-0.1,0.1-0.1,0.2,0c0.1,0.1,0.1,0.2-0.1,0.2C9.8,8.1,9.8,8,9.9,7.9 M9.1,8c0.1-0.1,0.2-0.1,0.2,0c0,0.1,0.2,0.1,0.3,0 c0-0.1,0.3,0,0.3,0C9.8,7.9,9.9,8,10,8c0.1,0,0,0-0.1,0.1c-0.2,0.1-0.2,0.1-0.3,0C9.5,8,9.4,8,9.1,8.1C9,8.1,9,8.1,9.1,8 M7,9.9 C7,9.9,7.1,10,7,9.9c0.1,0.1,0,0.1,0,0.1C7,10.1,6.9,10,7,9.9C6.9,10,7,9.9,7,9.9 M6.3,9.1c0.4,0,0.5-0.1,0.4-0.2 c-0.1,0-0.1-0.1,0.1-0.1c0.1,0,0.2,0,0.2,0.1C7,9,7,9,7,9c0,0-0.1,0-0.2,0.1C6.7,9.1,6.5,9.2,6.3,9.2C5.9,9.2,5.9,9.1,6.3,9.1 M4.1,8.9C4.2,9,4,9.1,3.9,9.1c0,0,0-0.1,0-0.1C4,8.9,4.1,8.9,4.1,8.9 M1,8.9c0.1,0,0.1,0,0.1,0.1S1.1,9.1,1,9.1 C0.9,9.1,0.9,9,0.9,9S0.9,8.9,1,8.9 M1,10.9C1,10.9,1.1,11,1.1,11C1,11.1,0.9,11.1,1,10.9C0.9,10.9,0.9,10.9,1,10.9 M43.1,19.9 L43.1,19.9C43.1,19.9,43.1,19.9,43.1,19.9c-0.1-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.1,0-0.1,0c0,0-0.1-0.1-0.1-0.1c-0.1,0-0.1-0.1-0.1-0.1 c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0.1-0.1l0,0l0,0c-0.1-0.1-0.2-0.2-0.1-0.2c0,0,0.1,0,0.1,0 c0,0,0.1,0.1,0.2,0.1l0,0L43,19L42.9,19c-0.1,0-0.2-0.1-0.2-0.1c0,0,0,0,0,0c0,0,0,0,0-0.1c0,0,0-0.1,0.1-0.1c0.1,0,0.1-0.1,0.1-0.1 l0,0l0,0c0.1,0,0.1,0.1,0.1,0l0,0c0,0,0,0,0,0l0-0.1c0,0,0-0.1,0-0.1c0-0.1-0.1-0.1-0.2-0.1l0,0l0,0l0,0l0,0c0,0,0-0.1,0-0.1 c0,0,0-0.1,0.1-0.2l0.1-0.1c0.1-0.1,0.1-0.2,0-0.2c-0.1,0,0-0.1,0.1-0.1c0,0,0.1,0,0.1-0.1c0-0.1,0.3-0.4,0.3-0.4c0,0,0,0.2-0.1,0.3 c0,0.1-0.1,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0,0,0.1c0.1,0.1,0.1,0.1,0,0.2c-0.1,0.1-0.1,0.2,0.1,0.1 c0.1,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0,0,0-0.1,0.1-0.1c0.1,0,0.2-0.1,0.2-0.2c0-0.1,0-0.1,0.1,0c0,0,0.1,0,0.1,0 c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0-0.1,0,0,0c0,0,0,0,0-0.1c0,0,0,0,0,0c0.1,0,0.1-0.1,0.1-0.1 c0-0.1,0.1-0.1,0.1,0c0,0.1,0,0.1,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.2-0.2,0.2-0.3c0-0.1,0.2-0.3,0.3-0.3c0,0,0,0,0,0.1 c0,0-0.1,0.1-0.1,0.2l0,0l0,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0.2-0.2,0.3-0.2c0,0,0.2-0.2,0.3-0.3c0.1-0.1,0.3-0.3,0.4-0.4 l0.1-0.1c0.1-0.1,0.1-0.1,0.2-0.1c0,0,0.1,0,0.2-0.1c0.1-0.1,0.1-0.1,0.1-0.2l0,0l0,0l0.1,0c0.1,0,0.1,0,0.1-0.1 c0-0.1,0-0.2,0.1-0.3l0,0.1l0,0c-0.1-0.1-0.2-0.2-0.2-0.3c0,0-0.1,0-0.1,0.1c0,0,0,0.1,0,0.2l0,0c0,0,0,0,0,0l-0.1,0.1 c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.1,0,0.1,0,0.1c0,0,0,0,0-0.1c0-0.2-0.1-0.1-0.2,0.1c0,0.1-0.1,0.2-0.1,0.1c0,0,0,0,0-0.1 c0-0.1,0.2-0.3,0.2-0.3c0,0,0-0.1,0-0.1c-0.1-0.1-0.1-0.1-0.1-0.1c0,0-0.1,0-0.1,0.1c0,0-0.1,0.1-0.1,0.1c0,0.1,0,0.1-0.1,0.1 c-0.1,0-0.1,0,0-0.2c0.1-0.1,0.1-0.2,0.1-0.2c0,0,0.1,0,0.1-0.1c0-0.1,0.1-0.1,0.1-0.1c0,0,0,0,0.1-0.1c0,0,0.1-0.1,0.2-0.2 c0.1-0.1,0.2-0.2,0.2-0.2c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0.1-0.1c0,0,0.1,0,0.1-0.1c0,0,0,0,0,0c0,0,0,0.1,0,0.2l0,0.1 c0,0,0,0.1,0,0.1c0,0.1,0.1,0.1,0.1,0c0,0,0-0.1,0.1-0.1c0.1,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0,0 c0,0,0.1,0,0.2-0.1c0.1-0.1,0.2-0.2,0.2-0.2c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.1c0,0,0.1,0,0.1,0c0,0,0-0.1-0.1-0.1c0,0,0,0,0,0 c0.1,0,0.1-0.1,0-0.1c0,0,0,0,0-0.1C47,13,47,13,47,13.1c0,0.1,0,0.1,0.1,0.1c0,0,0,0,0.1,0.1c0.1,0.1,0.1,0.1,0.1-0.1 c0-0.1,0-0.1,0.1-0.1l0,0c0,0,0,0,0-0.1c0-0.1,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1c0-0.1,0.1-0.1,0.1-0.2 c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0.1c0,0.1,0,0.1,0.1,0.1c0,0,0,0,0,0c0-0.1,0-0.2,0.2-0.2c0.1,0,0.1-0.1,0.1-0.1 c0-0.1,0.1-0.2,0.2-0.3c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0,0,0.1,0,0-0.1c0-0.1,0-0.1,0.1-0.2c0.1,0,0.1-0.1,0.1-0.1c0,0,0,0,0-0.1 c0,0,0-0.1,0-0.1c0,0,0.1-0.1,0.1-0.1c0-0.1,0.1-0.1,0.1-0.2c-0.4,0-0.5,0-0.5,0c0-0.1-0.3-0.1-0.4,0c-0.1,0.1-0.1,0.1-0.2,0.1 c-0.1,0-0.2,0-0.2,0C47.3,11,47.1,11,47,11c-0.1,0,0.2-0.2,0.3-0.2c0.2,0,0.1-0.1-0.1-0.1c-0.1,0-0.1,0-0.1,0.1c0,0.1,0,0.1-0.4,0.1 c-0.2,0-0.4,0-0.5,0.1c-0.1,0-0.1,0-0.1,0c0,0-0.1-0.1-0.3,0c-0.2,0-0.5,0-0.8,0c-0.4,0-0.5,0-0.5-0.1c0,0,0-0.1-0.1-0.1 c0,0-0.1,0-0.1,0.1c0,0-0.1,0.1-0.3,0.1c-0.3,0.1-0.5,0.1-0.5,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.1-0.1c0,0,0.1-0.1,0.1-0.1 c0,0,0.1,0,0.2,0l0,0l0.1,0l-0.1-0.1c-0.1,0-0.2-0.1-0.2,0c0,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.2,0 c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1,0,0.1,0.2,0.1c0.2,0,0.1,0.1-0.1,0.1c-0.1,0-0.2,0-0.2,0c0,0-0.1-0.1-0.2-0.1 c-0.1,0-0.2-0.1-0.3-0.1c0,0-0.2,0-0.4,0c-0.3,0-0.4,0-0.4,0c0,0-0.1,0-0.2,0c-0.2,0.1-0.9,0.1-0.9,0c0-0.1-0.1-0.1-0.3,0 c-0.1,0-0.2,0.1-0.2,0.1c0,0.1,0,0.1-0.1,0c0,0-0.1,0-0.2,0c0,0-0.3,0-0.5-0.1c-0.3-0.1-0.4-0.1-0.6,0c-0.1,0-0.2,0.1-0.2,0.1 c0,0.1-0.3,0.1-0.3,0c-0.1-0.1,0.5-0.4,0.7-0.4c0.1,0,0.3-0.1,0.2-0.1c-0.1-0.1-0.8-0.1-0.9,0c0,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.3,0.1 c-0.1,0-0.2,0.1-0.4,0.1c-0.1,0-0.3,0.1-0.3,0.1c-0.1,0-0.2,0.1-0.2,0.1l0,0l-0.1,0l0.1-0.1l0.1-0.1l-0.1,0c-0.1,0-0.2,0.1-0.3,0.2 c-0.2,0.2-0.3,0.2-0.3,0.1c0-0.1,0-0.1,0.1-0.1c0.1,0,0.2,0,0.2-0.1c0,0-0.1-0.1-0.2-0.1c-0.1,0-0.2,0-0.2-0.1c0,0-0.1-0.1-0.1-0.1 c-0.1,0-0.1,0-0.1,0.1c0,0,0,0.1-0.1,0.1s0,0,0-0.1c0.1-0.1-0.9-0.1-1,0c0,0-0.1,0.1-0.2,0.1l0,0l-0.2,0l0.2-0.1 c0.1,0,0.1-0.1,0.1-0.1c0,0-0.4,0-0.8,0c-0.4,0-1,0-1.3,0c-0.5,0-0.6,0-0.7,0.1c-0.1,0.1-0.2,0.1-0.5,0.1c-0.3,0-0.3,0-0.3-0.1 c0-0.1,0-0.1-0.1-0.1c-0.1,0-0.3,0.1-0.3,0.2c0,0-0.1,0-0.3,0c-0.2,0-0.3,0-0.2-0.1c0,0,0.1,0,0.2,0c0.1,0,0.1,0,0.1-0.1 c0,0-0.3-0.1-1,0c-1.1,0-1.4,0.1-1.3,0.2c0,0-0.1,0.1-0.1,0.1c-0.1,0-0.1,0,0,0c0.3-0.1,0-0.2-0.4-0.1c0,0-1.1,0-2.2,0 c-1.2,0-2.2,0.1-2.3,0.1c-0.1,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c-0.1,0.1-0.9,0-1.2,0c-0.2-0.1-3-0.1-3.3-0.1c-0.1,0-0.2,0.1-0.2,0.1 c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1-0.1c0-0.1-1.6-0.1-1.7,0c-0.1,0.1-0.2,0.1-0.2,0c0-0.1-0.1-0.1-0.4-0.1c-0.9,0-1.6,0-1.8-0.1 c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1,0-0.1,0c0-0.1,0-0.1-0.3-0.1c-0.7,0.1-1,0.1-1.3,0.1c-1.1,0-1.6,0-1.7,0c-0.1,0-0.2,0-0.4,0 c-0.2,0-0.4-0.1-0.5-0.1c-0.1,0-1.2,0-2.4,0c-1.2,0-2.3,0.1-2.4,0.1c-0.1,0-0.2,0-0.2,0c-0.1-0.1-1.3-0.1-1.3,0c0,0-0.3,0-0.6,0 c-0.3,0-0.6,0-0.7,0c0,0-0.1,0-0.1-0.1c-0.1-0.1-0.2-0.1-0.6-0.1l0,0l-0.5,0l-0.1-0.2c-0.1-0.2-0.2-0.2-0.1-0.1c0,0.1,0,0.1-0.1,0.1 c-0.1,0-0.1,0-0.2,0c-0.1,0.2-0.2,0.1-0.3-0.1C0,10.1,0,10,0.1,10c0,0,0.1,0,0.1,0.1c0,0.1,0.2,0.3,0.2,0.2c0,0,0-0.1,0-0.1 c-0.1-0.1-0.1-0.1,0-0.2c0,0,0-0.1,0-0.1c-0.1-0.1,0-0.1,0,0c0.1,0,0.1,0.1,0.1,0.1c0,0,0.1,0.1,0.1,0.1c0.1,0,0.1-0.1,0.1-0.2 c0-0.2,0-0.2-0.2-0.2c-0.1,0-0.1,0-0.1-0.1c0,0,0.1-0.1,0-0.1c0,0-0.1,0-0.1,0c-0.1,0.1-0.2,0.1-0.2,0c0,0,0-0.1,0.1-0.1 c0.1,0,0.1-0.1,0-0.1l0,0l-0.1,0l0.1-0.1c0.1,0,0.2-0.1,0.3-0.1c0.2,0,0.3-0.1,0.2-0.2c-0.1,0,0,0,0.1,0c0.1,0,0.2,0,0.2-0.1 c0-0.1,0.1-0.1,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0,0,0.1,0,0.2,0c0.1,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0.1-0.1,0.2-0.1,0.7-0.1 c0.2,0,0.3-0.1,0.3-0.2c0-0.1,0-0.1,0,0c0,0,0.1,0.1,0.1,0.1S3,8.5,3,8.5c0,0,0,0.1-0.1,0.1c-0.1,0-0.1,0-0.1,0.1 c0,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.1,0C3,8.8,3.5,8.8,3.6,8.7C3.7,8.6,3.9,8.5,4,8.5C4.4,8.5,5,8.4,5,8.5c0,0.1-0.1,0.2-0.4,0.2 c-0.1,0-0.3,0.1-0.4,0.1C4.2,8.9,4.2,8.9,4.8,8.9c0.3,0,0.6,0,0.6-0.1c0,0,0.1,0,0.2,0c0.2,0,0.4,0,0.4-0.2c0-0.1,0.2-0.1,0.2,0 c0,0,0,0.1-0.1,0.2C6.1,8.8,6,8.9,6.1,8.9c0,0,0.1,0,0.1,0l0,0c0.1-0.1,0.4-0.1,0.5,0C6.8,9,6.9,9,7,8.9c0.1-0.1,0.3-0.1,0.3,0 C7.3,9,7.4,9,7.5,8.9c0.2-0.1,1-0.1,1-0.1c0,0-0.1,0-0.2,0C8.2,8.9,8,9,8,9.1c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.1,0 c0.1,0.1,0.3,0.1,0.3,0C8.6,9,8.7,8.9,8.8,9c0,0,0.2,0,0.3,0c0.2,0,0.2,0,0.2-0.1c0-0.1,0-0.1,0-0.1c0,0,0.1,0,0.2,0 c0.1,0,0.1,0,0,0.1C9.3,9,9.4,9,9.7,8.8C9.8,8.7,9.9,8.7,10,8.7c0.1,0,0.1,0.1,0,0.2c-0.1,0-0.2,0.2-0.2,0.2c0,0,0.2,0,0.3,0 c0.3,0,0.6-0.1,0.7-0.2c0,0,0.1-0.1,0.2-0.1c0.1,0,0.2,0,0.2-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0,0.1,0.1c0,0,0,0.1,0.1,0.1 c0,0,0.1,0,0.1-0.1c0,0,0.1-0.1,0.2-0.1l0,0l0.2,0l-0.2-0.1c-0.3-0.1-0.3-0.2,0-0.2c0.2,0,0.3-0.1,0.2-0.1c0,0-0.2,0-0.3,0 c-0.4,0-0.4-0.1,0-0.1c0.2,0,0.4,0,0.4-0.1c0-0.1,0.1-0.1,0.1,0c0,0.1,0.3,0.1,0.4,0c0,0,0.1-0.1,0.2-0.1c0.1,0,0.1,0,0.1,0 c0-0.1-0.1-0.1-0.4-0.1c-0.2,0-0.2,0-0.1-0.1c0.2-0.1,0.1-0.1-0.1-0.1c-0.2,0-0.4,0.1-0.1,0.1c0.1,0,0.1,0,0.1,0.1c0,0-0.1,0-0.2,0 c-0.2-0.1-0.2-0.1-0.5,0.2l0,0l-0.3,0.2l-0.5,0c-0.4,0-0.5,0-0.7,0.1c-0.1,0-0.3,0.1-0.5,0.1c-0.2,0-0.3,0.1-0.4,0.1 c-0.1,0-0.1,0-0.1,0c0,0,0.1-0.1,0.3-0.1c0.2-0.1,0.2-0.1-0.4-0.1c-0.4,0-0.7,0-0.8,0.1c-0.1,0-0.1,0-0.1,0c0,0,0.1-0.1,0.2-0.1 c0.1,0,0.2-0.1,0.3-0.1C8.8,8,8.2,7.8,7.9,7.9C7.8,8,7.6,8,7.5,8c-0.1,0-0.3,0.1-0.4,0.1C7,8.3,6.9,8.3,6.3,8.3c-0.3,0-0.7,0-0.8,0 c-0.1,0-0.3,0-0.5,0c-0.2,0-0.3,0-0.3,0S4.9,8.1,5,8.1C5.1,8,5.3,8,5.6,8C6,8.1,6.2,8,6,7.9l0,0L5.8,7.8l0.2,0c0.1,0,0.2,0,0.3,0 c0.1,0,0.1,0.1,0,0.1C6.2,7.8,6.2,8,6.4,8.1c0.1,0.1,0.2,0.1,0.3,0C6.8,8,7,8,7.1,8c0.1,0,0.2,0,0.2-0.1c0,0,0.1-0.1,0.2-0.1 c0.3,0,1.4-0.1,1.6-0.1c0.1,0,0.2-0.1,0.3-0.1c0.1-0.1,0.1-0.1,0.2,0c0,0.1,0.4,0,0.5,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.1,0 c0,0,0-0.1,0,0c0,0,0.1,0,0.2,0c0.1,0,0.3-0.1,0.6-0.1l0.1,0c0.2,0,0.4,0,0.4,0c0,0,0.1,0,0.2,0c0.1,0,0.4,0,0.7,0.1 c0.4,0,0.6,0,0.7-0.1c0.1-0.1,0.2-0.1,0.4,0c0.2,0,0.2,0,0.2,0c0-0.1-0.1-0.2-0.3-0.2c-0.1,0-0.2,0-0.2-0.1c0-0.1,0-0.1,0.4,0 c0.2,0,0.5,0.1,0.8,0.1c0.3,0,0.6,0,0.7,0.1c0.2,0,0.3,0,0.3,0c0,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0c0.1-0.1,0.2-0.1,0.5,0 C17,7,17.1,7,17.4,6.9c0.2,0,0.4,0,0.4,0.1c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1-0.1C17.9,7,18,7,18.3,7c0.2,0,0.6,0,0.9,0 c0.3,0,0.5,0,0.6,0c0.1,0.1,0.2,0,0.1-0.1c-0.1,0-0.1-0.1,0-0.1c0,0,0.1,0,0.1,0.1c0,0,0.1,0,0.2,0c0.1,0,0.3,0,0.4,0 c0.3,0,0.3,0,0.3,0.1c0,0.1,0.9,0,1.2-0.1c0.1,0,0.3-0.1,0.3-0.1c0.1,0,0.3,0,0.5,0c0.2,0,0.5,0,0.6-0.1c0.2,0,0.2,0.1-0.1,0.1 c-0.2,0-0.2,0-0.1,0.1c0.2,0.1,0.7,0.1,0.7,0c0,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0c0.1,0,0.2-0.1,0.2,0c0.2,0.1,0.9,0,1-0.1 c0.1-0.1,0.2-0.1,0.1,0c0,0.1,0,0.1,0.2,0c0.1,0,0.4,0,0.5-0.1c0.1,0,0.3,0,0.5-0.1c0.1,0,0.2,0,0.2,0c0,0-0.1,0.1-0.1,0.1 c-0.2,0-0.2,0.1,0.1,0.1c0.2,0,0.2,0,0.3-0.1c0.1-0.1,0.2-0.1,0.3-0.1c0.3,0,0.5-0.1,0.7-0.1c0.1,0,0.1,0,0,0 c-0.1,0.1-0.5,0.2-0.7,0.2c-0.1,0-0.1,0-0.1,0c0,0.1-0.3,0.1-0.9,0.1c-0.5,0-0.8,0.1-0.8,0.2c0,0.1,1.3,0,1.3,0c0.1,0,0.5,0,0.7,0 c0.2,0.1,0.5,0,0.6-0.1c0.1-0.1,0.1-0.1,0.1,0c0.1,0.1,0.1,0.1,0.3,0c0.1,0,0.2,0,0.3-0.1C30.8,7,31.1,7,31.1,7c0,0,0,0.1,0.1,0.1 c0.1,0,0.1,0,0.1-0.1c0,0,0-0.1,0.1-0.1c0,0,0.1,0,0.1,0.1c0,0,0.1,0,0.1,0c0.2,0,0.6-0.1,0.7,0c0.1,0,0.1,0.1-0.1,0.1 c-0.1,0-0.1,0-0.1,0.1c0,0,0.1,0.1,0,0.1c0,0.1,0,0.1,0.1,0.1c0.1,0,0.2,0,0.3-0.1c0.1,0,0.2-0.1,0.3-0.1C32.9,7,32.9,7,33.1,7.1 c0.1,0,0.3,0,0.4,0c0.1,0,0.2,0,0.1,0c0,0-0.1,0.1-0.2,0.1c-0.1,0-0.2,0-0.2,0.1c-0.1,0,0,0.1,0.2,0.1c0.2,0,0.3-0.1,0.3-0.2 c0,0,0.1-0.1,0.3-0.1c0.2,0,0.3,0,0.3-0.1c0-0.1,1.1-0.2,1.2-0.2c0,0,0.3,0,0.6,0c0.4,0,0.6,0,0.7,0c0.1,0,0.2,0,0.5,0 c0.2,0,0.3,0,0.3,0c0,0,0.1,0,0.2,0c0.1,0,0.3,0,0.4,0c0.2,0,0.3,0,0.3,0c0-0.1,0.1-0.1,0.1,0C38.6,6.9,38.4,7,38,7l0,0l-0.4,0 l0.1,0.1c0.1,0.1,0.3,0.1,1.2,0c0.2,0,0.5,0,0.8-0.1c0.2,0,0.5-0.1,0.5-0.1C40.3,7,40.5,6.9,40.6,7c0.1,0,0.2,0,0.2,0 c0,0,0.1-0.1,0.3-0.1c0.1,0,0.3,0,0.4,0c0.1-0.1,0.1-0.1,0.1,0c-0.1,0.1,0,0.2,0.1,0.1c0,0,0.2,0,0.3,0c0.1,0,0.3,0,0.3-0.1 c0,0,0.1,0,0.1,0c0,0,0.1,0,0.2,0c0.1,0,0.5,0,1.1,0c0.5,0,1,0,1.1-0.1c0.2-0.1,0.5-0.1,0.5-0.1c0,0.1,0.1,0.1,0.4,0 c0.2-0.1,0.3-0.1,0.5-0.1c0.3,0.1,0.5,0,0.5-0.1c0-0.1,0-0.1,0.4-0.1c0.1,0,0.3,0,0.4,0c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1l0,0l0-0.1 l0.1,0.1c0.1,0.1,0.1,0.1,0.2,0.1c0,0-0.1-0.1-0.3-0.3c-0.2-0.2-0.4-0.3-0.4-0.4C46.7,5.6,46,5.1,46,5.1c-0.1,0,0,0.1,0.1,0.1 c0.1,0.1,0.1,0.1,0.1,0.1c0,0,0,0.1,0.1,0.1c0.1,0,0.2,0.1,0.2,0.2c0,0,0,0,0,0.1s0,0,0.1,0c0,0,0,0,0.1,0l0,0l0.1,0.1l-0.2,0 c-0.2,0-0.2,0-0.2,0c0,0,0,0,0,0c0,0.1,0.1,0.1,0.1,0c0-0.1,0-0.1-0.1-0.1c-0.2-0.1-0.2-0.2-0.2-0.2c0,0-0.2-0.2-0.3-0.2 c-0.1,0-0.1,0-0.2-0.2c-0.1-0.1-0.1-0.2-0.2-0.2c0,0-0.1,0-0.1-0.1c0,0-0.1-0.1-0.1,0c-0.1,0-0.3-0.1-0.2-0.1c0,0,0.2,0,0.3,0.1 c0.1,0.1,0.2,0.1,0.3,0.1c0,0,0-0.1-0.1-0.1c0,0-0.2-0.1-0.3-0.2c0,0-0.1-0.1-0.1-0.1c0,0-0.1,0-0.1-0.1c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0-0.1-0.1-0.1c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0-0.1c0-0.1,0-0.1-0.1-0.1 c0,0,0,0,0,0.1c0.1,0.1,0,0.1-0.1,0c-0.1-0.1-0.2-0.2-0.1-0.2c0.1,0.1,0.1,0.1,0.1,0.1c0,0,0,0,0-0.1l0,0l0,0c0,0,0,0-0.1,0 c-0.1-0.1-0.1-0.1-0.2-0.1c0,0-0.1,0-0.1,0c0,0,0,0,0.1-0.1l0,0l0,0c0,0,0,0,0,0l0,0c-0.1,0-0.1,0-0.2-0.1c0,0,0,0,0-0.1l0,0 c-0.1,0-0.1,0-0.1-0.1c0,0,0,0,0,0c0,0,0-0.1,0-0.1l0,0l0,0l0,0l0,0l0,0l0.1-0.1c0.1-0.1,0.1-0.2,0-0.3c-0.1-0.1-0.2-0.1-0.2-0.1 c0,0,0,0-0.1,0l0,0l0,0c0,0-0.1,0-0.1-0.1l-0.1-0.1c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0.1-0.1c0.1-0.1,0.1-0.1,0-0.1 c-0.1,0-0.2-0.1-0.4-0.3c-0.1-0.1-0.2-0.2-0.2-0.2c-0.1,0-0.1,0-0.1,0.1c0,0,0,0.1-0.1,0c0,0-0.1-0.1-0.1-0.1c0,0,0,0,0,0l0,0l0,0 l0,0l0,0l0,0l0,0c0.1,0,0.1,0,0.1,0l0,0c0,0,0.1,0,0.1-0.1c0,0,0-0.1,0-0.1c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0l0,0l0,0 c0,0-0.1-0.1-0.1-0.1l0,0l0,0l0,0c0.1-0.1,0.1-0.2,0.1-0.2l0,0c0,0-0.1-0.1-0.1,0c0,0,0,0-0.1,0.1l0,0l0,0l0,0c0,0-0.1-0.1-0.1-0.1 c0,0,0-0.1-0.1,0c0,0,0,0,0,0c0,0,0,0,0-0.1c0.1-0.1,0-0.2-0.1-0.2c0,0,0,0,0-0.1c0-0.1,0-0.1,0-0.1c0,0-0.1,0-0.1,0c0,0,0,0,0,0 c0,0,0,0,0,0c0.1,0,0.1,0,0.1-0.1c0-0.1,0-0.1,0-0.1c0,0,0.1-0.1,0.1-0.1c0-0.1,0.1-0.1,0.1-0.1c0,0,0,0,0.1,0c0,0,0,0,0.1,0 c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0.1l0,0l0,0c0.1-0.1,0.2-0.2,0.2-0.1c0,0,0,0.1,0,0.1c0,0-0.1,0.1-0.1,0.2l0,0l0.1,0.1 l0.1-0.1c0-0.1,0.1-0.2,0.1-0.2c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0.1c0,0.1,0.1,0.1,0.1,0.1l0,0l0,0c0,0.1-0.1,0.1,0,0.1 l0,0c0,0,0,0,0,0l0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.1-0.1,0.1-0.2l0,0l0,0l0,0l0,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.2,0.1l0.1,0.1 c0.1,0.1,0.2,0.1,0.2,0c0-0.1,0.1,0,0.1,0.1c0,0,0,0.1,0.1,0.1c0.1,0,0.4,0.3,0.4,0.3c0,0-0.2,0-0.3-0.1c-0.1,0-0.1-0.1-0.1,0 c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0c-0.1,0.1-0.1,0.1-0.2,0c-0.1-0.1-0.2-0.1-0.1,0.1 c0,0.1,0.1,0.1,0.1,0.1c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0.1C43.9,1,44,1.1,44,1.1c0.1,0,0.1,0,0,0.1c0,0,0,0.1,0,0.1 c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0-0.1c0,0,0-0.1,0,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0.1,0.1,0.1,0.1,0.1 c0.1,0,0.1,0.1,0,0.1c-0.1,0-0.1,0,0,0.1c0,0,0,0.1,0,0.1c0,0.1,0.2,0.2,0.3,0.2c0.1,0,0.3,0.2,0.3,0.3c0,0,0,0-0.1,0 c0,0-0.1-0.1-0.2-0.1l0,0l-0.1,0L44.9,2c0,0,0.1,0.1,0.1,0.1c0.1,0.1,0.2,0.2,0.2,0.3c0,0,0.2,0.2,0.3,0.3c0.1,0.1,0.3,0.3,0.4,0.4 l0.1,0.1C45.9,3.1,46,3.2,46,3.2c0,0,0,0.1,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1l0,0l0,0l0,0.1c0,0.1,0,0.1,0.1,0.1c0.1,0,0.2,0,0.3,0.1 l-0.1,0l0,0l0,0l0,0.1c0,0.2,0.1,0.1,0.3-0.1c0.1-0.1,0.1-0.2,0-0.2l0,0l0,0c0,0,0,0,0,0l-0.1,0c0,0-0.1,0-0.2,0l0,0c0,0,0,0,0,0 l-0.1-0.1c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0-0.1,0-0.1,0c0,0,0,0,0.1,0C46.3,3.2,46.2,3,46,3c-0.1,0-0.2-0.1-0.1-0.1c0,0,0,0,0.1,0 C46,2.8,46.2,3,46.3,3c0,0,0.1,0,0.1,0c0.1-0.1,0.1-0.1,0.1-0.1c0,0,0-0.1-0.1-0.1c0,0-0.1-0.1-0.1-0.1c-0.1,0-0.1,0-0.1-0.1 c0-0.1,0-0.1,0.2,0c0.1,0.1,0.2,0.1,0.2,0.1c0,0,0,0.1,0.1,0.1l0,0c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0.1,0.1c0,0,0.1,0.1,0.2,0.2 c0.1,0.1,0.2,0.2,0.2,0.2c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0.1c0,0,0,0.1,0.1,0.1c0,0,0,0,0,0c0,0-0.1,0-0.2,0l-0.1,0 c0,0-0.1,0-0.1,0c-0.1,0-0.1,0.1,0,0.1c0,0,0.1,0,0.1,0.1c0,0.1,0.1,0.1,0.1,0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0 c0,0,0,0.1,0.1,0.2c0.1,0.1,0.2,0.2,0.2,0.2c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1-0.1c0,0,0,0,0,0 c0,0.1,0.1,0.1,0.1,0c0,0,0,0,0.1,0c0.1,0.1,0.1,0.1,0,0.1c-0.1,0-0.1,0-0.1,0.1c0,0,0,0-0.1,0.1c-0.1,0.1-0.1,0.1,0.1,0.1 c0.1,0,0.1,0,0.1,0.1c0,0.1,0,0.1,0.1,0.1c0.1,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0.1,0.1,0.1,0.1c0.1,0,0.1,0.1,0.2,0.1 c0,0,0.1,0.1,0.1,0.1c0,0,0,0-0.1,0c-0.1,0-0.1,0-0.1,0.1c0,0,0,0,0,0c0.1,0,0.2,0,0.2,0.2c0,0.1,0.1,0.1,0.1,0.1 c0.1,0,0.2,0.1,0.3,0.2c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0c0,0,0,0.1,0.1,0c0.1,0,0.1,0,0.2,0.1c0,0.1,0.1,0.1,0.1,0.1c0,0,0,0,0.1,0 c0,0,0.1,0,0.1,0c0,0,0.1,0.1,0.1,0.1c0.1,0.1,0.2,0.1,0.2,0.2c0.2,0,0.3,0,0.3,0.1c0,0,0.1,0.1,0.1,0.2c0.1,0.1,0.2,0.2,0.2,0.2 c0,0,0,0.1,0.1,0.1c0,0,0.1,0.1,0.1,0.1c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0.1c0,0.1,0,0.1,0.1,0.1c0,0,0.1,0,0.1,0.1 c0,0,0.1,0.1,0.1,0.1c0,0,0.3,0.2,0.3,0.4C52.2,8,52.2,8,52.2,8c0,0,0.1,0,0.1,0.1c0.2,0.3,0.4,0.4,0.5,0.3c0,0,0,0.1-0.1,0.2 c-0.1,0.2-0.1,0.3-0.1,0.3c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0.1-0.1,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1 c0,0.1-0.1,0.1-0.2,0.1l0,0c0,0,0,0,0.1,0l0,0l0,0c0,0,0,0.1,0.1,0.1l0,0c0,0,0,0,0,0l0,0l0,0c0,0,0,0,0,0.1l0,0l0,0c0,0,0,0,0,0 l0,0.1c0,0,0,0.1,0.1,0.2c0.1,0.1,0,0.1-0.1,0.1c-0.1,0-0.1,0.1-0.1,0.2c0,0.1,0,0.2-0.1,0.2c0,0-0.1,0-0.1,0c0,0-0.1,0.1-0.2,0.1 c-0.1,0.1-0.5,0.4-0.7,0.6c-0.1,0.1-0.2,0.2-0.2,0.2c0,0-0.1,0.1-0.2,0.2C51.1,12,51,12.2,51,12.2c0,0-0.1,0.1-0.1,0.1c0,0,0,0,0,0 c0,0.1-0.2,0.3-0.4,0.5c-0.1,0.1-0.2,0.2-0.2,0.1c0,0-0.1,0-0.3,0.2c-0.1,0.2-0.3,0.3-0.3,0.3c-0.1,0.1-0.1,0.3-0.2,0.3 c0,0-0.3,0.2-0.3,0.3c0,0,0,0-0.1,0c0,0,0,0,0,0.1c0,0.1,0,0.1,0,0c0-0.1-0.1-0.1-0.1-0.1c0,0,0,0,0,0.1c0,0,0,0,0,0.1 c0,0,0,0,0,0.1c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1,0l0,0l-0.1,0l0.1-0.1c0.1-0.1,0.1-0.1,0.1-0.2c0,0-0.1,0.1-0.3,0.3 c-0.2,0.2-0.3,0.4-0.4,0.4c-0.1,0.1-0.6,0.8-0.6,0.8c0,0.1,0.1,0,0.1-0.1c0.1-0.1,0.1-0.1,0.1-0.1c0,0,0.1,0,0.1-0.1 c0-0.1,0.1-0.2,0.2-0.2c0,0,0,0,0.1,0c0,0,0,0,0-0.1c0,0,0,0,0-0.1l0,0l0.1-0.1l0,0.2c0,0.2,0,0.2,0,0.2c0,0,0,0,0,0 c0.1,0,0.1-0.1,0-0.1c-0.1,0-0.1,0-0.1,0.1c-0.1,0.2-0.2,0.2-0.2,0.2c0,0-0.2,0.2-0.2,0.3c0,0.1,0,0.1-0.2,0.2 c-0.1,0.1-0.2,0.1-0.2,0.2c0,0,0,0.1-0.1,0.1c0,0-0.1,0.1,0,0.1c0,0.1-0.1,0.3-0.1,0.2c0,0,0-0.2,0.1-0.3c0.1-0.1,0.1-0.2,0.1-0.3 c0,0-0.1,0-0.1,0.1c0,0-0.1,0.2-0.2,0.3c0,0-0.1,0.1-0.1,0.1c0,0,0,0.1-0.1,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0.1 c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0-0.1,0c-0.1,0-0.1,0-0.1,0.1c0,0,0,0,0.1,0 c0.1-0.1,0.1,0,0,0.1c-0.1,0.1-0.2,0.2-0.2,0.1c0.1-0.1,0.1-0.1,0.1-0.1c0,0,0,0-0.1,0l0,0l0,0c0-0.1,0-0.1,0-0.2l0-0.1 c-0.2-0.2-0.3,0.2-0.2,0.4l0,0l0,0l0,0c0,0,0,0,0,0l0,0c0,0.1,0,0.1-0.1,0.2c0,0,0,0-0.1,0l0,0l0,0l0,0l0,0l0,0 c0.1,0,0.1-0.1,0.1-0.1l0,0c0,0,0,0,0,0l0,0l0,0c0,0,0,0,0,0l0-0.1c0-0.1-0.1-0.1-0.1-0.1c0,0-0.1,0-0.2,0.1 c-0.1,0.1-0.2,0.1-0.1,0.2c0,0,0.1,0.1,0.1,0.1c0,0,0,0.1,0,0.1l0,0l0,0l0,0l0,0c0,0.1,0,0.1,0,0.2c-0.1,0.1-0.1,0.2-0.2,0.2 c-0.1,0-0.1,0-0.2-0.1l0,0l0,0c0,0,0,0.1-0.1,0.1l-0.1,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0-0.1-0.1c-0.1-0.1-0.1-0.1-0.1,0 c0,0.1-0.1,0.2-0.3,0.4c-0.1,0.1-0.2,0.2-0.2,0.2c0,0.1,0,0.1,0.1,0.1c0,0,0.1,0,0,0.1c0,0-0.1,0.1-0.1,0.1c0,0,0,0,0,0l0,0l0,0 c0,0.1,0,0.1,0,0c-0.1,0-0.1-0.1-0.1-0.1c0,0,0,0,0,0l0,0l0,0c0,0-0.1,0.1-0.1,0.1l0,0l0,0l0,0l0.1,0.1c0.2,0.2,0,0.2-0.2,0.1l0,0 l0,0l0,0c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0,0,0.1c0,0,0,0,0,0c0,0,0,0-0.1,0c-0.1-0.1-0.2,0-0.2,0.1c0,0,0,0-0.1,0c-0.1,0-0.1,0-0.1,0 C43.1,19.8,43.1,19.9,43.1,19.9C43.1,19.9,43.1,19.9,43.1,19.9L43.1,19.9z M43.4,1.4L43.4,1.4C43.4,1.3,43.4,1.3,43.4,1.4l0.1-0.1 l0,0l0,0l0,0c-0.1-0.1-0.3-0.2-0.3-0.3l0,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0l0,0c0,0,0,0,0-0.1c0-0.1,0-0.1-0.1-0.1c-0.1,0-0.1,0,0,0.1 c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0.1c0,0,0.1,0.1,0.1,0.1C43.3,1.2,43.3,1.3,43.4,1.4 C43.3,1.3,43.3,1.3,43.4,1.4L43.4,1.4z M45.8,3.9L45.8,3.9c0,0,0.1-0.1,0.1-0.1L46,3.8l0,0l0,0l0,0c-0.1-0.1-0.2-0.2-0.3-0.3l0,0 l0,0c0.1-0.1,0.1-0.1,0-0.2l0,0c-0.1,0-0.1-0.1-0.1-0.1c0,0,0-0.1,0-0.1c-0.1,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0l0,0l0,0L45.2,3 C45.1,2.9,45,2.8,45,2.8l0,0c0,0-0.1-0.1-0.2-0.1c-0.1-0.1-0.1-0.1-0.1-0.1c0.1,0,0.1,0,0-0.1c-0.1-0.1-0.1-0.1-0.1-0.1 c0,0,0,0,0.1,0c0,0,0.2,0.2,0.4,0.4C45.3,3,45.3,3,45.4,3c0,0,0.1,0-0.5-0.6C44.5,2,44.4,2,44.4,2c0,0,0,0,0,0l0,0l0,0 c-0.1,0.1-0.1,0.1-0.2,0.2l0,0c0.1,0.1,0.1,0.1,0.1,0.2l0,0c0,0,0,0.1,0.1,0.1c0.1,0,0.3,0.2,0.2,0.2c0,0,0,0.1,0.1,0.1 c0.1,0,0.1,0,0.1,0.1c0,0.1,0.2,0.3,0.3,0.3c0.1,0,0.1,0,0.1,0.1c0,0,0,0,0,0.1l0,0c0,0.1,0.1,0.2,0.1,0.2c0,0,0.1,0,0.1,0l0,0l0,0 l0,0l0.1,0.1c0.1,0.1,0.2,0.2,0.2,0.2C45.6,3.8,45.7,3.9,45.8,3.9C45.7,3.9,45.8,3.9,45.8,3.9L45.8,3.9z M43.6,3.1 c-0.1-0.1-0.2-0.1-0.2-0.2c0-0.1,0-0.1,0.1-0.2l0,0l0,0c0.1,0.1,0.1,0.1,0.2,0.1c0,0,0.1,0.2,0.1,0.2l0,0l0,0l0,0l0,0 C43.7,3.2,43.7,3.2,43.6,3.1z M44.1,3.5C44.1,3.5,44.1,3.5,44.1,3.5c0.2-0.1,0.2-0.1,0.2-0.1c0,0,0-0.1-0.1-0.2C44.1,3,44.1,3,44,3 c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1,0l0,0l0,0c0,0,0,0.1,0.1,0.1C44,3.4,44.1,3.4,44.1,3.5L44.1,3.5L44.1,3.5z M45.5,4.2 C45.5,4.2,45.5,4.2,45.5,4.2c0.2-0.1,0-0.4-0.2-0.7c-0.1-0.1-0.2-0.2-0.3-0.1c-0.1,0.1-0.2,0.3-0.1,0.3l0,0c0,0,0,0,0,0.1 c0,0.1,0,0.2,0.2,0.3C45.4,4.1,45.5,4.2,45.5,4.2z M44.4,3.8c0.1,0,0.1,0,0.2-0.1c0.2-0.2-0.2-0.3-0.4-0.2l0,0l0,0l0,0 c0,0,0.1,0,0.1,0.1C44.3,3.7,44.4,3.7,44.4,3.8L44.4,3.8L44.4,3.8z M47.7,5.5L47.7,5.5c0.1,0,0-0.1-0.4-0.5 c-0.2-0.2-0.5-0.5-0.8-0.8l-0.1-0.1l0,0l0,0c0,0,0,0-0.1,0l0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0.1,0.1,0.1c0,0,0,0,0.1,0.1 c0,0,0,0.1,0.1,0.1c0,0,0.1,0.1,0.2,0.2c0.1,0.1,0.2,0.1,0.2,0.1c0,0,0.1,0.1,0.2,0.1C47,5,47.1,5,47.1,5c0,0,0,0,0.1,0 c0,0,0,0,0,0.1c-0.1,0,0,0.1,0.1,0.1c0.1,0,0.3,0.1,0.2,0.2c-0.1,0,0,0.1,0,0.1C47.5,5.4,47.6,5.5,47.7,5.5 C47.7,5.5,47.7,5.5,47.7,5.5L47.7,5.5z M47,4.4c-0.1,0.1,0,0.1,0.2,0c0.1,0,0.1-0.1,0.2,0c0,0,0.1,0,0.1-0.1c0.1-0.1,0.1-0.1,0-0.1 c-0.1,0-0.2,0-0.3,0C46.8,4.3,46.7,4.3,47,4.4C47,4.4,47,4.4,47,4.4z M48.6,5.1c0,0.2,0.2,0.2,0.3,0c0-0.1,0-0.1-0.1,0 c-0.1,0.1-0.1,0-0.1,0c0-0.1,0-0.1,0-0.1c0,0-0.1,0-0.1,0c0,0-0.1,0-0.2,0l0,0L48.2,5l0.1,0c0,0,0.1,0,0.1,0.1 C48.4,5.1,48.5,5.1,48.6,5.1C48.5,5,48.6,5,48.6,5.1z M48,6c0.3,0.2,0.3,0.2,0.4,0.1c0.1-0.1,0.1-0.1,0-0.2 c-0.1-0.1-0.5-0.4-0.6-0.4c-0.1,0-0.3,0.1-0.2,0.2c0.1,0.2,0.2,0.2,0.2,0.2C47.8,5.9,47.9,5.9,48,6z M49.2,12.9 c0.1,0.1,0.1,0.1,0.2,0c0.1-0.2,0.1-0.3,0-0.5c-0.1-0.1-0.2,0-0.2,0.2c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0-0.1,0l0,0c0,0,0,0,0,0 C49.1,12.8,49.1,12.8,49.2,12.9L49.2,12.9L49.2,12.9L49.2,12.9L49.2,12.9z M47.5,13.4L47.5,13.4c0-0.1,0.1-0.2,0.1-0.2 c0,0,0-0.1,0-0.1c-0.1-0.1-0.1-0.1,0-0.1c0.2,0,0.2-0.2,0-0.3c-0.1,0-0.1,0,0,0.1c0.1,0.1,0,0.1,0,0.1c-0.1,0-0.1,0-0.1,0 c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.2l0,0L47.5,13.4z M48.2,14L48.2,14c0.2-0.1,0.3-0.2,0.2-0.2c0,0,0-0.1,0.1-0.2 c0.2-0.3,0.2-0.3,0.1-0.4c-0.1-0.1-0.1-0.1-0.2,0c-0.1,0.1-0.4,0.5-0.4,0.6C48,13.9,48.1,14.1,48.2,14L48.2,14z M46.7,15.4 L46.7,15.4C46.7,15.4,46.8,15.3,46.7,15.4c0.1-0.1,0.2-0.1,0.2-0.2c0,0,0,0,0.1-0.1c0,0,0.1,0,0.1-0.1c0,0,0.1-0.1,0.2-0.2 c0.1-0.1,0.1-0.2,0.1-0.2c0,0,0.1-0.1,0.1-0.2c0.1-0.1,0.1-0.1,0.1-0.2c0,0,0,0,0-0.1c0,0,0,0,0.1,0c0,0.1,0.1,0,0.1-0.1 c0-0.1,0.1-0.3,0.2-0.2c0,0.1,0.1,0,0.1,0c0,0,0-0.1,0.1-0.1c0,0,0-0.1,0-0.1c0,0-0.1,0-0.5,0.4c-0.2,0.2-0.5,0.5-0.8,0.8l-0.1,0.1 l0,0l0,0C46.7,15.3,46.7,15.4,46.7,15.4L46.7,15.4z M46.7,14.5c0,0.3,0.1,0.4,0.1,0.2c0-0.1,0-0.1,0.1-0.1c0.1,0.1,0.1,0,0-0.2 c0-0.1-0.1-0.1,0-0.2c0,0,0-0.1-0.1-0.1c-0.1-0.1-0.1-0.1-0.1,0C46.7,14.3,46.7,14.4,46.7,14.5z M46,16.2L46,16.2L46,16.2l0.1-0.1 c0.1-0.1,0.2-0.2,0.2-0.2c0,0,0.1,0,0.1-0.1c0,0,0,0,0-0.1l0,0l0,0c0,0,0,0-0.1-0.1l-0.1-0.1l0,0l0,0l0,0c-0.1,0.1-0.2,0.2-0.3,0.3 l0,0l0,0l0,0C46,16.1,46,16.1,46,16.2L46,16.2z M45.9,16.6c0.1,0.1,0.3,0.2,0.3,0.1l0,0c0,0,0,0,0.1,0c0.1,0,0.2,0,0.3-0.2 c0.1-0.2,0.2-0.3,0.2-0.3c0,0,0,0,0-0.1c-0.1-0.1-0.4,0-0.7,0.3C45.8,16.5,45.8,16.5,45.9,16.6z M44.7,17.5c0.1-0.1,0.2-0.1,0.2-0.1 c0,0,0.1,0,0.1-0.1c0-0.1,0.2-0.3,0.2-0.2c0,0,0.1,0,0.1-0.1c0-0.1,0-0.1,0.1-0.1c0.1,0,0.3-0.2,0.3-0.3c0-0.1,0-0.1,0.1-0.1 c0,0,0,0,0,0l0,0l0,0c0,0-0.1,0-0.1,0c0,0-0.1-0.1-0.1-0.1l0,0l-0.1,0.1c-0.1,0.1-0.2,0.2-0.2,0.3l0,0c0,0-0.1,0.1-0.1,0.2 C45,17,45,17,45.1,16.9c0-0.1,0-0.1-0.1,0C44.8,17,44.8,17,44.8,17c0,0,0,0,0-0.1c0,0,0.2-0.2,0.4-0.4c0.3-0.3,0.3-0.3,0.3-0.4 c0,0,0-0.1-0.6,0.5c-0.3,0.3-0.4,0.4-0.3,0.5c0,0,0,0,0,0l0,0l0,0C44.6,17.3,44.7,17.4,44.7,17.5L44.7,17.5z M43.2,18.8 C43.2,18.8,43.2,18.8,43.2,18.8c0.1,0,0.2-0.1,0.2-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1 c0.1-0.1,0.1-0.1,0.2-0.1c0,0,0,0,0,0l0,0l0,0c0,0,0,0-0.1-0.1l-0.1-0.1l0,0l0,0l0,0c-0.1,0.1-0.2,0.3-0.3,0.3l0,0c0,0,0,0,0,0.1 c0,0,0,0,0,0.1l0,0C43.3,18.6,43.3,18.7,43.2,18.8C43.2,18.7,43.2,18.7,43.2,18.8z",
            })
            /* eslint-enable */
          }
        }
      })

      button.addEventListener('mouseleave', (event) => {
        if (window.innerWidth > 1024) {
          if (event.target.classList != null && event.target.classList.contains('gradient-line-button')) {
            /* eslint-disable */
            gsap.to(svg, {
              duration: 0.8,
              x: 0,
              y: 0,
              scale: 1,
              // ease: Quint.easeOut,
              ease: 'power1.Out',
              morphSVG: original_path,
            })
            /* eslint-enable */
          }
        }
      })
    });


    /* eslint-disable */
    function open_modal_2(event, add_id) {
      // event.preventDefault();
      let modal_name = '';

      document.querySelector('.bws-header').classList.add('modal-open');
      document.querySelector('html').classList.add('no-overflow');

      // Used to allow appended elements to call modals
      // if (add_id != '') {
      //   modal_name = add_id.split('/');
      //   modal_name = modal_name[modal_name.length - 1];
      //   modal_name = modal_name.substring(1, modal_name.length);
      // } else {
      //   modal_name = event.target.getAttribute('href').toLowerCase();
      // }

      let modal = document.querySelector('#' + add_id);
      console.log(modal)
      let animated_items = modal.querySelectorAll('.animate-item');

        modal.classList.add('active');
        document.body.classList.add('no-overflow');

        /* eslint-disable */
        let animate_count = 0.2;
        animated_items.forEach(item => {
          gsap.to(item, {
            opacity: 1,
            delay: animate_count,
            duration: 1,
            y: 0,
            // ease: Quint.easeOut,
            ease: 'power1.Out',
          })
          animate_count += 0.2;
        });
        /* eslint-enable */

      // Used in modal close - to animate elements out
      return animate_items_out = reverse_array(animated_items);
    }

    function close_modal_2(event) {
      event.preventDefault();

      let modal_id = event.target.getAttribute('href');
      let current_modal = document.getElementById(modal_id);
      let total = 0;
      let animate_items = '';

      if (current_modal.querySelectorAll('.animate-item').length > 0) {
      animate_items = current_modal.querySelectorAll('.animate-item');
      /* eslint-disable */
        // Animate the elements out
        let animate_count = 0.2;
        animate_items.forEach(item => {
          gsap.to(item, {
            opacity: 0,
            delay: 0.3,
            duration: 0.3,
            y: -30,
            // ease: Quint.easeOut,
            ease: 'power1.Out',
          });
          /* eslint-enable */
          animate_count += 0.2;
        });

        total = 600;
      } else {
        total = 200;
      }

      setTimeout( () => {
        current_modal.classList.remove('active');
        document.querySelector('html').classList.remove('no-overflow');
        document.querySelector('.bws-header').classList.remove('modal-open');

      }, total);
    }

    let close_2 = document.querySelectorAll('.close-modal-trigger-2');
    close_2.forEach(close => {
      close.addEventListener('click', close_modal_2)
    })

    // Breat cancer promotional modal
    if (document.body.classList.contains('home')) {
      // setTimeout(() => {
      //   open_modal_2('', 'general-modal')
      // }, 5000)
    }

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js